module.exports = require("@apollo/client/link/retry");